import React from "react";

// Single source of truth for the disclaimer shown beneath the client dashboard
// grids. Both columns cover the medical line of coverage only -- dental and vision
// are excluded (see DashboardRateCalculator in OpenEnrollmentService).
//
// The two columns deliberately report different figures over different plan sets.
// Current Cost is the employer share (what the company pays after employee
// contributions) across everything on this year's bill, terminated plans included.
// Percentage Increase compares total premium to total premium and skips terminated
// plans, since a plan going away has no renewal rate to compare against; that keeps
// it aligned with the % Change column on the client summary screen.

export const MEDICAL_ONLY_NOTE =
  "Note: Current Cost is the employer share of medical premium, including plans being terminated. Percentage Increase compares total medical premium at current and renewal rates, and excludes terminated plans. Dental and vision are excluded.";

// Muted grey used for secondary/explanatory text across the app.
export const NOTE_COLOR = "#7D807D";

/**
 * Small muted note rendered directly under a dashboard grid.
 */
export default function MedicalOnlyCostNote({ style }) {
  return (
    <div
      data-testid="medical-only-note"
      style={{
        fontSize: "14px",
        color: NOTE_COLOR,
        fontStyle: "italic",
        marginTop: "8px",
        ...style,
      }}
    >
      {MEDICAL_ONLY_NOTE}
    </div>
  );
}
